import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {ApplicantProfile} from '../../../types';

export const useDreamJobSection = (profile: ApplicantProfile): FormSection[] => {
  const {t: tfd} = useTranslation('translation', {keyPrefix: 'applicantProfile.form.dreamJob'});

  return useMemo<FormSection[]>(
    () => [
      {
        type: 'textarea',
        data: {
          name: 'dreamJobDescription',
          placeholder: tfd('placeholder'),
          label: tfd('label'),
          initialValue: profile.dreamJobDescription,
          schema: Yup.string().min(2, 'Too Short!').max(2000, 'Too Long!'),
        },
      },
    ],
    [profile.dreamJobDescription, tfd]
  );
};
